import logo from "../img/heading-logo-removebg-preview.png";
import { Link, useNavigate } from "react-router-dom";
import { FiMapPin } from "react-icons/fi";
import { CiMail } from "react-icons/ci";
import { FaPhone } from "react-icons/fa6";
import { t } from "i18next";

const HeaderMain = () => {
  const navigate = useNavigate();
  return (
    <div className="header-main d-flex w-100 justify-content-between align-items-center">
      <div className="col-6 col-md-3 d-flex align-items-center">
        <img
          src={logo}
          alt="zto-logo"
          className="zto-logo"
          onClick={() => navigate("/")}
        />
      </div>
      <div className="col-md-6 d-none d-md-flex justify-content-between align-items-center">
        <div className="col-sm-6 d-flex align-items-center justify-content-between">
          <div
            className=""
            style={{
              marginRight: "0.5rem",
            }}
          >
            <FiMapPin size={30} color="#004d9f" />
          </div>
          <div className="d-flex flex-column">
            <span>{t("header-main.officeAddressHaNoiTitle")}</span>
            <span>{t("header-main.officeAddressHaNoiDetail")}</span>
          </div>
        </div>
        <div className="col-sm-6 d-flex align-items-center justify-content-between">
          <div
            className=""
            style={{
              marginRight: "0.5rem",
            }}
          >
            <FiMapPin size={30} color="#004d9f" />
          </div>
          <div className="d-flex flex-column">
            <span>{t("header-main.officeAddressHCMTitle")}</span>
            <span>{t("header-main.officeAddressHCMDetail")}</span>
          </div>
        </div>
      </div>

      <div className="col-6 col-md-3 d-flex flex-column justify-content-center align-items-end contact-info">
        <a href="tel:0364758606" className="hotline-card-main">
          <div className="hotline-icon-circle">
            <FaPhone size={22} className="phone-ring-main" />
          </div>
          <div className="hotline-info">
            <span className="hotline-label-main">Hotline</span>
            <span className="hotline-number-main">0364.758.606</span>
          </div>
        </a>
      </div>
    </div>
  );
};

export default HeaderMain;
